<div class="position-relative">
  <div
    #inputElementWrapper
    class="input-wrapper position-relative d-flex align-items-flex-end"
    [style]="{ gap: spaceBetweenItem() }"
  >
    <!-- Custom Template or Default Phone Number Input -->
    <ng-container
      *ngIf="customInputTemplate; else defaultPhoneNumberInput"
      [ngTemplateOutlet]="customInputTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          value: value,
          control: control,
          onInput: onInputChange.bind(this),
          onBlur: onTouched.bind(this),
          onFocus: onTouched.bind(this)
        }
      }"
    ></ng-container>
  </div>

  <!-- Helper Text  Template -->
  <ng-container *ngIf="helperText">
    <div [innerHTML]="helperText | safeHtml"></div>
  </ng-container>

  <div *ngIf="showErrors && control?.invalid && control?.touched" class="error-container" role="alert">
    <div class="is-vertical-align mt-1">
      @for (error of control.errors | keyvalue; track error.key) {
      <small class="typog-xs text-error">
        {{ getErrorMessageBasedOnKey(error) }}
      </small>
      }
    </div>

    <!-- Custom Error Template -->
    <ng-container
      *ngIf="customErrorTemplate"
      [ngTemplateOutlet]="customErrorTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          control: control,
          errors: control.errors
        }
      }"
    ></ng-container>
  </div>
</div>

<ng-template #defaultPhoneNumberInput>
  @if (!attachToInput) {
  <!-- Selector template -->
  <ng-template #customSelectedOption>
    <span class="d-inline-flex gap-2">
      @if (showCountryFlag) {
      <span class="d-contents" [innerHTML]="selectedCountryOption?.currencyFlag ?? '' | safeHtml"></span>
      }
      <span>{{ selectedCountryOption?.dial_code }} </span>
    </span>
  </ng-template>

  <!-- Dropdown menu list template -->
  <ng-template #customOption let-countryList>
    <span class="d-inline-flex gap-2">
      @if (showDropdownMenuCountryFlag) {
      <span class="d-contents" [innerHTML]="countryList.currencyFlag | safeHtml"></span>
      }
      <span
        >{{ countryList.dial_code }}

        @if (showCountryName) {
        {{ countryList?.title }}
        }
      </span>
    </span>
  </ng-template>

  <finxone-select-dropdown
    id="country-code"
    [formControl]="countryCodeFormControl"
    [options]="countryList"
    [customOptionTemplate]="customOption"
    [customSelectedOptionTemplate]="customSelectedOption"
    [optionLabelKey]="'title'"
    [optionValueKey]="'dial_code'"
    [appendToBody]="true"
    [searchEnabled]="allowSearch"
    [selectedOption]="selectedCountryOption?.title ?? ''"
    [label]="labelType === labelTypeOptions.STATIC ? label : ''"
    (selectionChange)="onCountryChangeEvent()"
    [dropdownWidth]="elementContentWidth"
    [isDropdownDisabled]="isDropdownDisabled"
    [inputLabelTooltipText]="!attachToInput ? inputLabelTooltipText : ''"
  >
  </finxone-select-dropdown>
  }

  <finxone-input
    [ngClass]="{
        'is-vertical-align justify-content-end': labelType === labelTypeOptions.STATIC,
      }"
    class="w-100"
    [type]="type"
    [id]="id"
    [name]="name"
    [disableAutocomplete]="disableAutocomplete"
    [label]="labelType !== labelTypeOptions.STATIC || attachToInput ? label : ''"
    [formControl]="control"
    [value]="control?.value ?? ''"
    [placeholder]="placeholder ?? ''"
    [isVerifyButtonShown]="isVerifyButtonShown() ?? false"
    [isVerifyButtonGlobalStylingAllowed]="isVerifyButtonGlobalStylingAllowed"
    [verifyButtonGlobalStylingClass]="verifyButtonGlobalStylingClass"
    [verifyButtonStyle]="verifyButtonStyle"
    [verifyButtonTextContent]="verifyButtonTextContent"
    [spaceBetweenElementUnit]="spaceBetweenElementUnit() ?? ''"
    [spaceBetweenElementValue]="spaceBetweenElementValue() ?? 0"
    [inputMode]="inputMode"
    (input)="onInputChange($event)"
    (buttonClicked)="verifyPhone()"
    [inputLabelTooltipText]="attachToInput ? inputLabelTooltipText : ''"
  >
  </finxone-input>
</ng-template>
